export function isNetworkError(error: unknown) {
  if (error instanceof Error) {
    return snippets.some(
      (s) => error.message.toLowerCase().includes(s.toLowerCase()) || error.name.toLowerCase().includes(s.toLowerCase())
    )
  } else {
    return false
  }
}

const snippets = ['Failed to fetch', 'Load failed', 'Gateway Time-out', 'Bad Gateway', 'signal is aborted without reason']
